import { fetchNotifications } from "../data/query.js";
import { useMenuAxios } from "../context/axios.js";
import { useQuery } from "@tanstack/react-query";
//#region src/modules/core/hooks/use-notifications-query.ts
var useNotificationsQuery = () => {
	const { instance } = useMenuAxios();
	return useQuery({
		queryKey: ["notifications"],
		queryFn: () => fetchNotifications(instance),
		enabled: false
	});
};
//#endregion
export { useNotificationsQuery };
